import React, {useState, useEffect, useRef, useCallback} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {Button} from 'react-bootstrap';
import { errorToast } from "../../components/DommusToast";
import { trackPromise } from "react-promise-tracker";
import DommusLoadingArea from "../DommusLoading/DommusLoadingArea";
import urlHelper from "../../helpers/UrlHelper";
import { useDownloadAudio } from '../../hooks/useDownloadAudio';
import './style.scss';

export default function DommusBase64AudioPlayer({promiseBuscaAudio, base64audio, mimeType, indice}){
  const [srcAudio, setSrcAudio] = useState((base64audio && ("data:audio/wav;base64, " + base64audio)) || null)
  const [buscando, setBuscando] = useState(false);
  const audioRef = useRef(null);
  const { configDownloadAudio, downloadBase64Audio } = useDownloadAudio();

  useEffect(() => {
    return function cleanup () {
      if(srcAudio && !base64audio && audioRef && audioRef.current){
        audioRef.current.addEventListener("canplaythrough", event => {
          audioRef.current.play();
        });
      }
      if(srcAudio && audioRef && audioRef.current){
        audioRef.current.pause();
      }
    }
  }, [srcAudio, audioRef.current])

  const buscarBase64 = ()=>{
    setBuscando(true);
    trackPromise(promiseBuscaAudio().then((response) => {
      if(response.data){
        const novoAudio = "data:" + (mimeType || 'audio/wav') + ";base64, " + response.data;
        setSrcAudio(novoAudio);
        setBuscando(false);
      }else{
        errorToast.fire({ text: "Gravação não encontrada." });
      }
    }).catch((error) => console.log(error)), ('promiseAudioArea' + indice));
  }

  const handleDownloadAudio = useCallback(() => {
    if (!srcAudio) return;
    try {
      downloadBase64Audio(srcAudio, mimeType);
    } catch (error) {
      errorToast.fire({ text: "Erro ao baixar áudio." });
      console.error(error);
    }
  }, [srcAudio, mimeType]);

  return <>
    <DommusLoadingArea area={("promiseAudioArea" + indice)} fundo={"#fff"} />
      {(
      srcAudio ? (
        <div className="audio-player-container">
          <audio
            className="audioGravacao"
            controls
            preload="metadata"
            ref={audioRef}
            controlsList={!configDownloadAudio ? 'nodownload' : ''}
          >
              <source src={srcAudio} type={mimeType} />
          </audio>
          {configDownloadAudio && (
            <Button 
              variant="outline-primary" 
              className="btn-download-audio"
              onClick={handleDownloadAudio}
              title="Baixar áudio"
            >
              <FontAwesomeIcon icon={faDownload} />
            </Button>
          )}
        </div>
      ) : (!buscando && <Button variant="outline-primary" onClick={buscarBase64}><FontAwesomeIcon icon={faDownload} style={{marginRight:"0.5rem"}}/>Buscar Áudio</Button>)
    )}
  </>
}
